import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { MainComponent } from './layout/main/main.component';

@Component({
    selector: 'app-root',
    imports: [CommonModule, MainComponent],
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss']
})
export class AppComponent {
}
